const Styles = () => ({
  textField: {
    '& > *': {
      margin: '15px 0px'
    },
  },
  root: {
    marginBottom: '100px'
  },
  icon: {
    color: 'white',
    fontSize: '75px'
  }
});

export default Styles;